import type { CSMSDKQueue } from '@atlassian/customer-service-management-widget-sdk-types';

export const createSDKQueue = (): CSMSDKQueue => {
	const q: CSMSDKQueue = function CMSQueue(...args) {
		q.__q__.push(args);
	};
	q.__q__ = [];
	return q;
};
